import React, { useState } from 'react';
import { Faq } from '../../../api/entities';
import { FAQListComponent } from '../components/faq.list.component';
import '../components/styles/faq.list.style.scss';
import { TopicFilterComponent } from '../components/topic.filter.component';

export interface IFAQViewProps {}

export const FAQView: React.FC<IFAQViewProps> = () => {
    const [faqList, setFaqList] = useState<Array<Faq>>([]);

    const handleOnTopicClick = async (faqs: Array<Faq>) => {
        setFaqList(faqs);
    };

    return (
        <div style={{ margin: '100px', marginBottom: '120px' }}>
            <div className='d-flex row' style={{ gap: '3%' }}>
                <TopicFilterComponent onTopicClick={handleOnTopicClick} />
                <FAQListComponent faqs={faqList} />
            </div>
        </div>
    );
};
